<template>
  <div class="w-100" id="tableContent">
    <div class="row" id="selectorCPP">
      <div class="col-2" id="textCantPPArea">
        {{ $t("page.table.cant_elementos") }}
      </div>
      <div class="col-1" id="selectorCantPP">
        <select class="custom-select" v-model="cantPP" @change="cambioCantPP()">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div
        v-if="cargando"
        class="col-12 text-center"
        style="margin-top: 200px; z-index: 1000"
      >
        <h4>{{ $t("page.general.cargar") }}</h4>
      </div>
      <div
        :class="{ table_loading: cargando }"
        class="col-12"
        style="overflow-x: auto"
        id="tablaContent"
      >
        <table
          style="table-layout: fixed; width: 100%"
          :id="name"
          class="table table-striped table-bordered"
          data-reorderable-columns="true"
        >
          <thead>
            <tr>
              <th data-sortable="true" class="indice" style="width: 25px"></th>
              <th
                data-sortable="true"
                v-bind:style="{
                  width: column.width + 'px'
                }"
                class="py-3 table_theader_component"
                v-on:click="setOrder(column.nomfield)"
                v-for="(column, index) in columns_with_selects"
                :key="'columnws2' + index"
              >
                {{ $t(column.column) }}
                <small class="ml-auto close">
                  <i
                    v-show="orderBy == column.nomfield && orderByType == 'asc'"
                    class="fas fa-sm fa-arrow-up"
                  />
                  <i
                    v-show="orderBy == column.nomfield && orderByType == 'desc'"
                    class="fas fa-sm fa-arrow-down"
                  />
                </small>
              </th>
            </tr>
            <tr>
              <th data-sortable="true" class="indice" style="width: 20px"></th>
              <th
                data-sortable="true"
                v-bind:style="{
                  width: column.width + 'px'
                }"
                class="pb-0"
                v-for="(column, index) in columns_with_selects"
                :key="'columnws' + index"
              >
                <form
                  v-on:submit.prevent="Consultar"
                  autocomplete="off"
                  class="form-group"
                >
                  <input
                    :placeholder="[[$t('page.content_empleados.tabla.todos')]]"
                    v-on:change="Filtrando(false)"
                    v-if="column.input == 'text' || column.input == 'number'"
                    v-on:focus="$event.target.select()"
                    :type="column.input"
                    v-model="columns[index].filter"
                    @input="setFilterToColumns(index)"
                    class="form-control form-control-sm"
                    :id="column.nomfield"
                  />
                  <div
                    id="selectorAll"
                    v-else-if="
                      name.toLowerCase() == 'inscribir personal' &&
                        selectorAll &&
                        column.nomfield == 'boton_Agregar'
                    "
                  >
                    <button
                      class="btn p-1 btn-primary"
                      id="btnAddAll"
                      @click="inscribeAll()"
                      :disabled="column.disponibles < cantidad_registros"
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                  <div v-else-if="column.input == 'checkbox' && selectorAll">
                    <span
                      id="span-selectorall"
                      data-v-3ec4129a
                      v-if="cantidad_registros > 15000"
                    >
                      <a
                        data-trigger="hover"
                        data-container="body"
                        style="color: #a1aab2 !important"
                        class="btn btn-link pt-1 pl-0"
                        title="Seleccionar todos"
                        data-toggle="popover"
                        data-content="Para poder seleccionar todos deben haber menos de 15.000 registros"
                      >
                        <i></i>
                      </a>
                    </span>

                    <input
                      @click="selectAll($event)"
                      :type="column.input"
                      :checked="checkedAll"
                      v-model="checkedAll"
                      class="form-control form-control-sm selectorAll"
                      :id="column.nomfield"
                    />
                  </div>
                  <input
                    v-on:change="Filtrando(true)"
                    v-else-if="column.input == 'date'"
                    data-date-format="mm/dd/yyyy"
                    :type="column.input"
                    v-model="column.filter"
                    class="form-control form-control-sm datepicker"
                    :id="column.nomfield"
                  />
                  <select
                    v-else-if="column.input == 'select'"
                    class="form-control form-control-sm"
                    v-model="column.filter"
                    v-on:change="Filtrando(true)"
                    :id="column.nomfield"
                  >
                    <option value="Todos">
                      {{ $t("page.content_empleados.tabla.todos") }}
                    </option>

                    <option
                      :value="select"
                      v-for="(select, index) of column.selects"
                      :key="'selector' + index"
                    >
                      <span v-if="column.nomfield == 'estatus'">
                        {{ select == 0 ? "Activa" : "Inactiva" }}
                      </span>
                      <span v-else>
                        <span v-if="column.nomfield == 'obligatoria'">
                          {{ index == 0 ? "Opcional" : "Obligatoria" }}
                        </span>
                        <span v-else>
                          <span>
                            <span v-if="column.nomfield == 'interno'">
                              {{ select == 0 ? "Externo" : "Interno" }}
                            </span>
                            <span v-else>
                              <span v-if="column.nomfield != 'activo'">
                                <span
                                  v-if="
                                    column.nomfield != 'curso_cerrado' &&
                                      column.nomfield !=
                                        'empleados_calificaciones.acreditado' &&
                                      column.nomfield != 'disponible' &&
                                      column.nomfield != 'baja_logica' &&
                                      column.nomfield !=
                                        'cat_empleados.baja_logica' &&
                                      column.nomfield != 'confirmado' &&
                                      column.nomfield != 'acreditado' &&
                                      column.nomfield != 'tiene_firma'
                                  "
                                  >{{ select }}</span
                                >
                                <span v-else>
                                  {{ select == 1 ? "SI" : "NO" }}
                                </span>
                              </span>
                              <span v-else>
                                {{ select == 1 ? "Activo" : "Inactivo" }}
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </option>
                  </select>
                </form>
              </th>
            </tr>
          </thead>
          <div
            v-if="datos.length == 0 && !cargando"
            class="row justify-content-md-center mt-3"
            style="width: 95vw"
          >
            <div class="col-auto">
              <h5>{{ $t("page.table.no_data") }}</h5>
            </div>
          </div>
          <tbody v-else>
            <tr v-for="(dato, index) in datos" :key="'dato' + index">
              <td class="text-center indice" style="width: 20px">
                {{ index + 1 }}
              </td>
              <td
                style="word-wrap: break-word"
                v-bind:style="{
                  width: column.width + 'px'
                }"
                :class="{
                  'text-center': column.input == 'img',
                  'text-center': column.input == 'button',
                  'text-center': column.nomfield == 'usuario_activo',
                  'text-center': column.input == 'enlace'
                }"
                class="py-2"
                v-for="(column, index1) in columns"
                :key="'column' + index1"
              >
                <img
                  style="max-height: 20px; max-width: 30px"
                  class="rounded-circle px-0 mx-auto"
                  v-if="column.input == 'img'"
                  :src="column.field(dato)"
                  alt=""
                />
                <a
                  v-else-if="
                    column.input == 'enlace' &&
                      column.nomfield == 'localizacion'
                  "
                  class="btn btn-sm btn-success"
                  target="_blank"
                  :href="column.field(dato)"
                >
                  {{ $t("page.content_recursos_formacion.sedes.abrir_mapa") }}
                  <i class="fas fa-map-marker-alt"></i>
                </a>
                <button
                  class="btn px-0 btn-link btn_link_blue"
                  v-on:click="$emit('Edit', dato)"
                  v-else-if="
                    column.input == 'button' && column.nomfield == 'edit'
                  "
                >
                  <i class="fas fa-lg fa-edit"></i>
                </button>
                <div v-else-if="name == 'Registros de alta de empleados' && column.nomfield =='certificado' " class="row justify-content-center">
                  <span v-if="column.field(dato).toLowerCase() == 'certificado'"><i style="color:#00ab53;" class="fas fa-circle"></i></span>
                  <span v-else> <i style="color:#df4759;" class="fas fa-circle"></i></span>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'button' && column.nomfield == 'btn_delete'
                  "
                >
                  <button
                    class="btn btn-danger btn-sm"
                    v-on:click="$emit('DeleteItem', dato)"
                    v-if="column.condicion(dato)"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'button' && column.nomfield == 'btn_temas'
                  "
                >
                  <button
                    class="btn btn-success btn-md"
                    v-on:click="$emit('getTemas', dato)"
                  >
                    {{ column.field(dato) }}
                  </button>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'button' &&
                      column.nomfield == 'liberar_sesion'
                  "
                >
                  <button
                    class="btn btn-success btn-md"
                    v-on:click="$emit('liberar_sesion', dato)"
                  >
                    <i class="fas fa-cogs"></i>
                  </button>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'button' &&
                      column.nomfield == 'restablecerPass'
                  "
                >
                  <button
                    class="btn btn-danger btn-sm"
                    v-on:click="$emit('restablecerPass', dato)"
                  >
                    <i class="fas fa-cogs"></i>
                  </button>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'button' &&
                      column.nomfield == 'btn_participantes'
                  "
                >
                  <button
                    class="btn btn-secondary btn-outline"
                    v-on:click="$emit('participantesAction', dato)"
                  >
                    <i class="fa fa-thumbs-o-up text" aria-hidden="true">
                      {{ dato.participantes }}
                    </i>
                    <i
                      class="fa fa-thumbs-o-up text-active text-danger"
                      aria-hidden="true"
                    >
                      {{ dato.participantes }}
                    </i>
                  </button>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'button' &&
                      column.nomfield == 'btn_invitacion'
                  "
                >
                  <button
                    class="btn btn-primary btn-outline"
                    v-on:click="$emit('invitacionAction', dato)"
                    v-if="column.condicion(dato)"
                  >
                    <i class="fa fa-thumbs-o-up text" aria-hidden="true">
                      <i class="fas fa-lg fa-envelope"></i>
                    </i>
                    <i class="fa fa-thumbs-o-up text-active" aria-hidden="true">
                      <i class="fas fa-lg fa-envelope"></i>
                    </i>
                  </button>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'button' && column.nomfield == 'btn_action'
                  "
                >
                  <button
                    class="btn p-1 btn-primary"
                    v-on:click="$emit('Accion_boton', dato)"
                  >
                    {{ $t(column.textoBoton) }}
                  </button>
                </div>

                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'button' && column.nomfield == 'btn_action_cond'
                  "
                >
                  <button
                    class="btn p-1 btn-primary"
                    v-on:click="$emit('Accion_boton', dato)"
                    :disabled="column.condicion(dato) == false"
                  >
                    {{ $t(column.textoBoton) }}
                  </button>

                </div>

                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'button' &&
                      column.nomfield == 'btn_action_icon'
                  "
                >
                  <button
                    class="btn p-1 btn-primary"
                    v-on:click="$emit('Accion_boton', dato)"
                  >
                    <i :class="column.icon"></i>
                  </button>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'button' && column.nomfield == 'btn_meet'
                  "
                >
                  <a
                    class="btn-link mb-0 pb-0e"
                    v-on:click="$emit('meetAction', dato)"
                  >
                    <img
                      src="static/img/meet.png"
                      alt=""
                      class="img-fluid mb-0 pb-0"
                      style="max-height: 36px"
                    />
                  </a>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'button' && column.nomfield == 'costo_total'
                  "
                >
                  <button
                    class="btn btn-secondary btn-outline"
                    v-on:click="$emit('costosAction', dato)"
                    v-if="column.condicion()"
                  >
                    <i class="fa fa-thumbs-o-up text" aria-hidden="true">
                      $ {{ dato.costo_total }}
                    </i>
                    <i
                      class="fa fa-thumbs-o-up text-active text-white"
                      aria-hidden="true"
                    >
                      $ {{ dato.costo_total }}
                    </i>
                  </button>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="column.input == 'date'"
                >
                  {{
                    (new Date(column.field(dato)).getDate()+1) +
                      " " +
                      meses[new Date(column.field(dato)).getMonth()] +
                      " " +
                      new Date(column.field(dato)).getFullYear()
                  }}
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'select' &&
                      column.nomfield == 'curso_cerrado'
                  "
                >
                  <span v-if="dato.curso_cerrado == 1"> SI </span>
                  <span v-else> NO </span>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'select' && column.nomfield == 'disponible'
                  "
                >
                  <span v-if="dato.disponible == 1"> SI </span>
                  <span v-else> NO </span>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'select' && column.nomfield == 'interno'
                  "
                >
                  <span v-if="dato.interno == 1"> Interno </span>
                  <span v-else> Externo </span>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="column.nomfield == 'acreditado'"
                >
                  <span v-if="dato.acreditado == ''"> NO </span>
                  <span v-else> SI </span>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="column.nomfield == 'estatus'"
                >
                  <span v-if="dato.estatus == 0"> Activa </span>
                  <span v-else> Inactiva </span>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.nomfield == 'inscrito_otro_curso' ||
                      column.nomfield == 'tabla.inscrito_otro_curso'
                  "
                >
                  <span v-if="column.field(dato) == 'No'"> NO </span>
                  <div class="col-auto" v-else-if="column.field(dato) == 'Si'">
                    <button
                      type="button"
                      class="btn btn-success popoverBtn"
                      data-toggle="popover"
                      title="Administrar inscripciones"
                      @click="popoverAction(dato)"
                    >
                      SI
                    </button>
                  </div>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.nomfield == 'tabla.requerido_por_plan' ||
                      column.nomfield == 'requerido_por_plan'
                  "
                >
                  <span> {{ dato.requerido_por_plan }} </span>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="column.nomfield == 'cat_instructores.cve_empleado'"
                >
                  <span v-if="column.field(dato) == 0"> Externo </span>
                  <span v-else> Interno</span>
                </div>
                <div
                  class="row justify-content-md-center"
                  v-else-if="
                    column.input == 'select' && column.nomfield == 'tiene_firma'
                  "
                >
                  <span v-if="column.field(dato) == false"> NO </span>
                  <span v-else> SI</span>
                </div>

                <div
                  class="row btn-center justify-content-md-center"
                  v-else-if="
                    column.input == 'button' && column.nomfield == 'boton_Firma'
                  "
                >
                  <button
                    class="btn p-1 btn-primary"
                    v-on:click="$emit('Accion_boton', dato)"
                  >
                    <i class="fas fa-pencil-alt"></i>
                    {{ $t(column.textoBoton) }}
                  </button>
                </div>
                <div
                  class="row btn-center justify-content-md-center"
                  v-else-if="
                    column.input == 'button' &&
                      column.nomfield == 'btn_liberar_intentos' &&
                      column.condicion(dato)
                  "
                >
                  <button
                    class="btn p-1 btn-primary"
                    v-on:click="$emit('Accion_boton', dato)"
                  >
                    <i class="fas fa-cogs"></i>
                  </button>
                </div>

                <div
                  class="row btn-center justify-content-md-center"
                  v-else-if="
                    column.input == 'button' &&
                      column.nomfield == 'boton_Constancia'
                  "
                >
                  <button
                    class="btn btn-sm btn_blue"
                    v-on:click="$emit('Accion_constancia', dato)"
                    v-if="column.condicion(dato)"
                  >
                    <i class="fas fa-cloud-download-alt"></i>
                    {{ column.textoBoton }}
                  </button>
                </div>

                <div
                  class="row btn-center justify-content-md-center"
                  v-else-if="
                    column.input == 'button' && column.nomfield == 'boton_DC3'
                  "
                >
                  <button
                    class="btn btn-sm btn-success"
                    v-on:click="$emit('Accion_dc3', dato)"
                    v-if="column.condicion(dato)"
                  >
                    <i class="fas fa-cloud-download-alt"></i>
                    {{ column.textoBoton }}
                  </button>
                </div>

                <div
                  class="row btn-center justify-content-md-center"
                  v-else-if="
                    column.input == 'button' &&
                      column.nomfield == 'add_tema_planta'
                  "
                >
                  <button
                    class="btn p-1 btn-primary"
                    v-on:click="$emit('add_tema_planta', dato)"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>

                <div
                  class="row btn-center justify-content-md-center"
                  v-else-if="
                    column.input == 'button' &&
                      column.nomfield == 'boton_Mostrar'
                  "
                >
                  <button
                    class="btn p-1 btn-primary"
                    v-on:click="$emit('Accion_mostrar', dato)"
                  >
                    <i
                      class="fas fa-eye"
                      v-if="column.column != 'Calificación B'"
                    ></i>
                    <span v-else>{{ column.field(dato) }}</span>
                    {{ column.textoBoton }}
                  </button>
                </div>

                <div
                  class="row btn-center justify-content-md-center"
                  v-else-if="
                    column.input == 'button' &&
                      column.nomfield == 'boton_Eliminar'
                  "
                >
                  <button
                    class="btn p-1 btn-danger btn-sm"
                    v-on:click="$emit('Accion_eliminar', dato)"
                  >
                    <i class="fas fa-trash-alt"></i>
                    {{ column.textoBoton }}
                  </button>
                </div>
                <div
                  class="row btn-center justify-content-md-center"
                  v-else-if="
                    column.input == 'button' && column.nomfield == 'boton_Emp'
                  "
                >
                  <button
                    class="btn p-1 btn-sm"
                    v-on:click="$emit('ver_Empleado', dato)"
                  >
                    <i class="fas fa-lg text-dark fa-male"></i>
                    {{ column.textoBoton }}
                  </button>
                </div>
                <div
                  class="row btn-center justify-content-md-center"
                  v-else-if="
                    column.input == 'button' &&
                      column.nomfield == 'participantes'
                  "
                >
                  <button
                    class="btn btnParticipantes"
                    v-on:click="$emit('ver_Empleado', dato)"
                  >
                    {{ column.field(dato) }}
                  </button>
                </div>
                <div
                  class="row btn-center justify-content-md-center"
                  v-else-if="
                    column.input == 'button' &&
                      column.nomfield == 'boton_Agregar'
                      && column.condicion(dato)
                  "
                >
                  <button
                    class="btn p-1 btn-danger btn-sm"
                    v-on:click="$emit('Accion_agregar', dato)"
                    v-if="!column.field(dato)"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
                <div v-else-if="column.input == 'dropdown'">
                  <div class="btn-group">
                    <button
                      type="button"
                      class="btn btn-sm btn-info dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {{ $t(column.texto_dropdown) }}
                    </button>
                    <div class="dropdown-menu">
                      <a
                        :key="'dropdownOption' + index"
                        v-for="(item, index) in column.options"
                        class="dropdown-item"
                        href=""
                        v-on:click.prevent="$emit(item.emit, dato)"
                        v-if="item.condicion(dato)"
                        >{{ $t(item.text) }}</a
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="row btn-center justify-content-md-center"
                  v-else-if="
                    column.input == 'button' && column.nomfield == 'enlace'
                  "
                >
                  <a class="btn px-0 btn-primary">
                    {{ column.textoBoton }}
                  </a>
                </div>
                <div
                  class="row btn-center justify-content-md-center"
                  v-else-if="
                    column.input == 'button' &&
                      column.nomfield == 'boton_Firma1'
                  "
                >
                  <button
                    class="btn p-1 btn-primary"
                    v-on:click="$emit('Accion_boton1', dato)"
                  >
                    <i class="fas fa-pencil-alt"></i>
                    {{ $t(column.textoBoton) }}
                  </button>
                </div>
                <div
                  v-else-if="column.input == 'checkbox'"
                  v-on:click="selectRow(dato, $event)"
                  class="form-check"
                >
                  <input
                    class="
                      form-check-input
                      row
                      btn-center
                      justify-content-md-center
                    "
                    type="checkbox"
                    :checked="column.field(dato) == 1"
                    id="defaultCheck1"
                  />
                </div>
                <button
                  class="btn px-0 btn-link btn_link_dorada"
                  v-else-if="
                    column.input == 'button' && column.nomfield == 'favorite'
                  "
                >
                  <i v-if="dato.cargando" class="fas fa-spinner fa-spin" />
                  <i
                    v-else-if="dato.favorite"
                    v-on:click="Eliminar_Favorito(dato, index)"
                    class="fas fa-lg fa-star"
                  />
                  <i
                    v-else
                    v-on:click="Agregar_Favorito(dato, index)"
                    class="far fa-lg fa-star"
                  />
                </button>
                <span
                  v-else-if="
                    column.nomfield == 'usuario_activo' &&
                      column.field(dato) == 'Activo'
                  "
                  class="badge badge-success"
                >
                  {{ column.field(dato) }}
                </span>
                <span
                  v-else-if="
                    column.nomfield == 'usuario_activo' &&
                      column.field(dato) == 'Sin Acceso'
                  "
                  class="badge badge-danger"
                >
                  {{ column.field(dato) }}
                </span>
                <span v-else>
                  {{ column.field(dato) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="!cargando && datos.length > 0" class="row mt-3">
      <div
        v-if="cantidad_registros > 10"
        class="col-3 mr-5 text-left pt-1 pl-3"
      >
        <!-- Agregar validacion para el numero de resultados totales de la paginacion de las tablas-->
        <div
          v-if="pages.length * 10 > cantidad_registros && page == pages.length"
        >
          <b>{{ cantidad_registros }}</b> {{ $t("page.table.de") }}
          <b>{{ cantidad_registros }} {{ $t("page.table.registros") }}</b>
        </div>
        <div v-else>
          <b>{{ cantActual }}</b> {{ $t("page.table.de") }}
          <b>{{ cantidad_registros }} {{ $t("page.table.registros") }}</b>
        </div>
      </div>
      <div v-else class="col-3 mr-5 text-left pt-1 pl-3">
        <b>{{ cantidad_registros }}</b> {{ $t("page.table.de") }}
        <b>{{ cantidad_registros }} {{ $t("page.table.registros") }}</b>
      </div>
      <div class="col-8">
        <div class="row justify-content-end">
          <div class="col-auto text-center">
            <button
              v-if="page == ultima_page"
              v-on:click="page = 1"
              :class="{
                'btn-primary': page == 1,
                'btn-secondary': page != 1
              }"
              class="btn"
            >
              1
            </button>
          </div>
          <div v-if="page == ultima_page" class="col-auto pt-3 text-center">
            <b>.</b>
            <b>.</b>
            <b>.</b>
          </div>
          <div v-for="pagina of pages" class="col-auto text-center">
            <button
              v-on:click="page = pagina.number"
              :class="{
                'btn-primary': pagina.active,
                'btn-secondary': !pagina.active
              }"
              class="btn"
            >
              {{ pagina.number }}
            </button>
          </div>
          <div
            v-if="ultima_page > pages.length && page != ultima_page"
            class="col-auto pt-3 text-center"
          >
            <b>.</b>
            <b>.</b>
            <b>.</b>
          </div>
          <div class="col-auto text-center">
            <button
              v-if="ultima_page > pages.length && page != ultima_page"
              v-on:click="page = ultima_page"
              :class="{
                'btn-primary': page == ultima_page,
                'btn-secondary': page != ultima_page
              }"
              class="btn"
            >
              {{ ultima_page }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Vue from "vue";
export default {
  props: [
    "name",
    "columns",
    "url",
    "order",
    "ordertype",
    "selects",
    "selectindex",
    "fechainicial",
    "fechafinal",
    "selectorAll",
    "sendFechas",
    "reload",
    "filtersEXT"
  ],
  data() {
    return {
      historialSelectAll: [],
      cargando: true,
      page: 1,
      orderBy: "",
      posicion_cargando: null,
      posicion: null,
      cantidad_registros: 0,
      filtrando: false,
      orderByType: "asc",
      columns_with_selects: [],
      pages: [],
      ultima_page: 1,
      datos: [],
      checkedAll: false,
      origen: [{ dato: "Interno", dato: "Externo" }],
      cantPP: 10,
      meses: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic"
      ]
    };
  },
  methods: {
    cambioCantPP() {
      this.page = 1;
    },
    inscribeAll() {
      this.$emit("selectAll", {
        page: this.page,
        fecha_inicial: this.fechainicial,
        fecha_final: this.fechafinal,
        columns_with_selects: this.columns_with_selects,
        order: this.orderBy,
        ordertype: this.orderByType
      });
    },
    reordenar() {
      $(function() {
        $(`#${this.name}`).bootstrapTable();
      });
    },

    cerrarPopovers() {
      $(`[data-toggle='popover']`).popover("hide");
    },

    popoverAction(ev) {
      $('[data-toggle="popover"]').popover("hide");
      let that = this;
      let template = `
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <p>
              Deseas cancelar la inscripcion de {{ ev.nombre_empleado }} Al curso
              {{ ev.cve_curso }}
            </p>
          </div>
        </div>
        <div class="row justify-content-center">
          <button type="submit" @click="eliminar(ev)" class="btn btn-danger">Aceptar</button>
        </div>
      </div>
      `;

      let compo = Vue.component("popover_form", {
        data() {
          return { ev };
        },
        template: template,
        methods: {
          eliminar() {
            //console.log("eliminar", ev);
            that.$emit("eliminarPopover", ev);
          }
        }
      });
      var instance = new compo({
        propsData: { ev }
      });
      this.instance = instance;
      this.instance.$mount();
      //console.log(this.instance);
      setTimeout(() => {
        $(".popover-body").append(instance.$el);
        $(".popover.show").hover(
          function() {
            //console.log("está sobre el popover")
          },
          function() {
            that.cerrarPopovers();
          }
        );
      }, 100);
    },

    mover() {
      $(function() {
        var pressed = false;
        var start = undefined;
        var startX, startWidth;

        $("table th").mousedown(function(e) {
          start = $(this);
          pressed = true;
          startX = e.pageX;
          startWidth = $(this).width();
          $(start).addClass("resizing");
        });

        $(document).mousemove(function(e) {
          if (pressed) {
            $(start).width(startWidth + (e.pageX - startX));
          }
        });

        $(document).mouseup(function() {
          if (pressed) {
            $(start).removeClass("resizing");
            pressed = false;
          }
        });
      });
    },

    setFilterToColumns(index) {
      this.columns_with_selects[index].filter = this.columns[index].filter;
    },
    selectRow(dato, e) {
      if (e.target.checked) {
        this.$emit("Select", dato);
      } else {
        this.$emit("Delete", dato);
      }
    },
    selectAll(e) {
      if (e.target.checked) {
        this.$emit("selectAll", {
          page: this.page,
          fechainicial: this.fechainicial,
          fechafinal: this.fechafinal,
          columns_with_selects: this.columns_with_selects,
          order: this.orderBy,
          ordertype: this.orderByType,
          ultima_page: this.ultima_page
        });
        this.historialSelectAll.push(JSON.stringify(this.columns));
      } else {
        this.$emit("removeAll", {
          page: this.page,
          fechainicial: this.fechainicial,
          fechafinal: this.fechafinal,
          columns_with_selects: this.columns_with_selects,
          order: this.orderBy,
          ordertype: this.orderByType,
          ultima_page: this.ultima_page
        });

        this.historialSelectAll = this.historialSelectAll.filter(el => {
          el != JSON.stringify(this.columns);
        });
      }
    },
    Validar_Seleccionados() {
      if (this.selects != undefined || this.selects != null) {
        for (var i = 0; i < this.datos.length; i++) {
          for (var x = 0; x < this.selects.length; x++) {
            if (
              eval("this.datos[i]." + this.selectindex) ==
              eval("this.selects[x]." + this.selectindex)
            ) {
              this.datos.selected = 1;
            }
          }
        }
      }
    },
    Agregar_Favorito(dato, posicion) {
      this.datos[posicion].cargando = true;
      this.posicion_cargando = posicion;
      this.$emit("AddFavorite", {
        dato: dato,
        posicion: posicion
      });
    },
    Eliminar_Favorito(dato, posicion) {
      this.datos[posicion].cargando = true;
      this.posicion_cargando = posicion;
      this.$emit("DeleteFavorite", {
        dato: dato,
        posicion: posicion
      });
    },
    Filtrando(consultar) {
      this.filtrando = true;
      if (consultar) {
        this.Consultar();
      }
    },
    setOrder(field) {
      if (
        field != "liberar_sesion" &&
        field != "btn_temas" &&
        field != "btn_costos" &&
        field != "btn_meet" &&
        field != "btn_invitacion" &&
        field != "btn_delete" &&
        field != "btn_participantes" &&
        field != "btn_drop" &&
        field != "boton_Firma" &&
        field != "boton_Firma1" &&
        field != "edit" &&
        field != "favorite" &&
        field != "selected" &&
        field != "boton_Mostrar" &&
        field != "boton_Eliminar" &&
        field != "boton_DC3" &&
        field != "boton_Constancia" &&
        field != "boton_Emp" &&
        field != "link_img" &&
        field != "total_temas" &&
        field != "boton_Agregar"
      ) {
        if (field == this.orderBy) {
          if (this.orderByType == "asc") {
            this.orderByType = "desc";
          } else {
            this.orderByType = "asc";
          }
        } else {
          this.orderBy = field;
          this.orderByType = "asc";
        }

        this.Consultar();
      }
    },

    /**
     * Consulta de datos
     *
     * Esta funcion nos permite obtener los registros que se desea visualizar en las tablas
     */

    async Consultar() {
      let that = this;
      //Validacion del url hacia donde se realiza la consulta de datos
      //Se valida en caso de que el url sea vacio o contenga un parametro indefinido
      if (this.url != "" && this.url.indexOf("undefined") === -1) {
        this.Cargando();
        if (this.filtrando) {
          this.page = 1;
        }
        this.checkedAll = false;
        let body;
        //Definicion del body de la consulta estos son los parametros que se recibe en la consulta para obtener los datos deseados
        if (this.filtersEXT == undefined) {
          body = {
            //La primera pagina donde se ubicaran determinado numero de registros
            page: this.page,

            //Fecha inicial nos permite filtrar sierta informacion segun la fecha, esta presente solo en algunos componentes table
            fecha_inicial: this.fechainicial,

            //Fecha final nos permite filtrar sierta informacion segun la fecha, esta presente solo en algunos componentes table
            fecha_final: this.fechafinal,
            columns_with_selects: this.columns_with_selects,

            //El order de los resultados esto depende de la variables que se haya definido en cada componente table
            order: this.orderBy,

            //El tipo de ordenamiento que puede tener los resultado, este puede ser ascendente o descente
            ordertype: this.orderByType,

            //La cantidad de resultados que se quiere mostrar en la primera pagina
            cantPP: this.cantPP
          };
        } else {
          body = {
            page: this.page,
            fechainicial: this.fechainicial,
            fechafinal: this.fechafinal,
            columns_with_selects: this.columns_with_selects,
            order: this.orderBy,
            ordertype: this.orderByType,
            cantPP: this.cantPP,
            filtersEXT: this.filtersEXT
          };
        }

        //Peticion http que se realiza para obtener los registros
        await this.$http
          .post(this.url, body)
          .then(respuesta => {
            return respuesta.json();
          })
          .then(respuestaJson => {
            this.datos = respuestaJson.result;
            this.Validar_Seleccionados();
            this.pages = respuestaJson.pages.pages;
            this.ultima_page = respuestaJson.pages.ultima_page;
            this.cantidad_registros = respuestaJson.pages.cantidad_registros;
            this.columns_with_selects = respuestaJson.columns_with_selects;
            this.menu.excel.data = respuestaJson.result;
            this.menu.excel.query = {
              url: this.url,
              fecha_inicial: that.menu.filtros.fechas.fecha_inicial,
              fecha_final: that.menu.filtros.fechas.fecha_final,
              columns_with_selects: respuestaJson.columns_with_selects,
              order: this.orderBy,
              ordertype: this.orderByType,
              cantPP: this.cantPP
            };
            this.updateCkecks();
            $('[data-toggle="popover"]').popover();
          })
          .catch(error => {
            swal(
              "¡Ups!",
              "Problemas para consultar la información de " + this.name,
              "error"
            );
          })
          .finally(response => {
            this.Listo();
            this.filtrando = false;
          });
        this.checkedAll = this.historialSelectAll.includes(
          JSON.stringify(this.columns)
        );
      }
    },
    ListoFavorite() {
      if (this.posicion != null) {
        this.datos[this.posicion].cargando = false;
        this.datos[this.posicion].favorite = !this.datos[this.posicion]
          .favorite;
        this.posicion = null;
        this.posicion_cargando = null;
      }
    },
    Cargando() {
      this.cargando = true;
    },
    Listo() {
      var that = this;
      this.cargando = false;
    },
    updateCkecks() {
      this.Cargando();
      this.datos = this.datos.map(el => {
        el.selected = false;
        return el;
      });
      try {
        for (let key = 0; key < this.datos.length; key++) {
          let element = this.datos[key];
          for (let key1 = 0; key1 < this.selects.length; key1++) {
            let element1 = this.selects[key1];
            //element.selected = false;
            if (element[this.selectindex] == element1["value"]) {
              this.datos[key].selected = true;
            }
          }
        }
      } catch (error) {}
      this.Listo();
    }
  },
  computed: {
    menu() {
      return this.$store.getters.getMenu;
    },
    cantActual() {
      if (this.cantidad_registros < this.page * this.cantPP) {
        return this.cantidad_registros;
      } else {
        return this.page * this.cantPP;
      }
    }
  },
  watch: {
    url: function() {
      this.page = 1;
      this.Consultar();
    },
    cantPP: function() {
      this.Consultar();
    },
    page: function(oldValue, newValue) {
      this.Consultar();
    },
    posicion_cargando(oldValue, newValue) {
      if (this.posicion_cargando != null) {
        this.posicion = this.posicion_cargando;
      }
    },
    selects: function() {
      this.updateCkecks();
    },
    reload: function() {
      this.Consultar();
    }
  },
  mounted() {
    this.orderBy = this.order;
    this.orderByType = this.ordertype;
    this.columns_with_selects = this.columns;
    this.Consultar();

    // this.mover();
    // this.reordenar();
  },
  created() {
    var that = this;
    this.$parent.$on("update", this.Consultar);
    this.$parent.$on("favorite_update", this.ListoFavorite);
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://cdn.jsdelivr.net/npm/jqueryui@1.11.1/jquery-ui.min.js"
    );
    document.body.appendChild(recaptchaScript);
    let recaptchaScript1 = document.createElement("script");
    recaptchaScript1.setAttribute(
      "src",
      "https://cdn.jsdelivr.net/gh/akottr/dragtable@master/jquery.dragtable.js"
    );
    document.body.appendChild(recaptchaScript1);
    let recaptchaScript2 = document.createElement("script");
    recaptchaScript2.setAttribute(
      "src",
      "https://unpkg.com/bootstrap-table@1.18.3/dist/bootstrap-table.min.js"
    );
    document.body.appendChild(recaptchaScript2);
    let recaptchaScript3 = document.createElement("script");
    recaptchaScript3.setAttribute(
      "src",
      "https://unpkg.com/bootstrap-table@1.18.3/dist/extensions/reorder-columns/bootstrap-table-reorder-columns.min.js"
    );
    document.body.appendChild(recaptchaScript3);
    let recaptchaScript4 = document.createElement("link");
    recaptchaScript4.setAttribute(
      "href",
      "https://cdn.jsdelivr.net/gh/akottr/dragtable@master/dragtable.css"
    );
    document.body.appendChild(recaptchaScript4);
    let recaptchaScript5 = document.createElement("link");
    recaptchaScript5.setAttribute(
      "href",
      "https://unpkg.com/bootstrap-table@1.18.3/dist/bootstrap-table.min.css"
    );
    document.body.appendChild(recaptchaScript5);
  }
};
</script>

<style>
.indice {
  width: 25px !important;
}
.table_theader_component {
  cursor: pointer;
}
.table_loading {
  opacity: 0.5;
  margin-top: -250px;
}
.btn-link {
  cursor: pointer;
}
.seleccionar_todos {
  font-size: 0.5em;
}
#span-selectorall {
  position: absolute;
}
#btnAddAll {
  left: 49px;
  position: absolute;
  top: 90px;
}
@media (min-width: 1366px) and (max-width: 1920px) {
  #btnAddAll {
    left: 55px;
    position: absolute;
    top: 90px;
  }
}
#selectorCPP {
  padding-bottom: 1em;
  padding-left: 1em;
}
#selectorCantPP {
  min-width: 7em;
}
#textCantPPArea {
  text-align: left;
}

/* div:first-of-type + span{
  color:blue
} */

.btnParticipantes {
  background-color: #7d7d7d;
  color: white;
}

thead {
  background-color: white;
}

.btn {
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Herramientas/table.vue